/***
*
*   PRICING
*   Modify the PricePlans component with your own features
*
**********/

import React from 'react';
// eslint-disable-next-line no-unused-vars
import { Animate, Row, PricePlans } from 'components/lib';
import Styles from './pricing.module.scss'
import { PlanComponent } from 'components/pricing/PlanCard';

export function Pricing(props) {

  return (
    <Animate type='pop'>
      <Row color='tint' align='center' title='Simple, affordable pricing'>
      </Row>

      <div id='plansContainer' className={Styles.plansContainer}>
        <PlanComponent />
      </div>
    </Animate>
  )
}
